module.exports = __webpack_public_path__ + "static/media/jw_platinum.89822fae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/Templates/Backgrounds/jw_platinum.jpg
// module id = 747
// module chunks = 0